import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { useGetCurrentUser, useGetCurrentUserSuspense } from '@omnea-app/fe-users-and-groups/useGetCurrentUser'
import { DEFAULT_CURRENCY } from '@omnea-app/packages/universal/currency-utils/getCurrencyCodes'

export const useOrganisationDefaultCurrency = () => {
  const { user } = useAuthenticatedUser()
  const { data: userData, isLoading } = useGetCurrentUser(user.id)
  return { defaultCurrency: userData?.orgDefaultCurrency ?? DEFAULT_CURRENCY, isLoading }
}

export const useOrganisationDefaultCurrencySuspense = () => {
  const { user } = useAuthenticatedUser()
  const { data: userData } = useGetCurrentUserSuspense(user.id)
  return userData?.orgDefaultCurrency ?? DEFAULT_CURRENCY
}
